<template>
  <a-modal width="55%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
    :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
    <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
      <a-row :gutter="24">
                <!--可编辑区域 start-->
                <div class="hidden">
                    <a-form-item label="id" name="id">
                        <a-input v-model:value="form.id" />
                    </a-form-item>
                </div>
                <a-col :span="24">
                    <a-form-item label="机构logo" prop="logo">
                                    <img-upload v-model:value="form.logo" />
                                </a-form-item></a-col>
                <a-col :span="12">
                    <a-form-item label="姓名" prop="name">
                                    <a-input disabled="true" v-model:value="form.name" placeholder="请输入机构名称" />
                                </a-form-item></a-col>
                <a-col :span="12">
                    <a-form-item label="机构类型" prop="type">
                                    <DictSelect
                                        v-model:value="form.type"
                                        :dict-name="financeDict.ORGANIZATIONTYPE"
                                        placeholder="请选择"
                                    />
                                </a-form-item></a-col>
                <a-col :span="12">
                    <a-form-item label="邮编" prop="postcard">
                                    <a-input v-model:value="form.postcard" placeholder="请输入邮编" />
                                </a-form-item></a-col>
                <a-col :span="12">
                    <a-form-item label="公司网址" prop="webSite">
                                    <a-input v-model:value="form.webSite" placeholder="请输入公司网址" />
                                </a-form-item></a-col>
                <a-col :span="12">
                    <a-form-item label="地区" name="prov">
                                    <city-select v-model:prov="form.prov" v-model:city="form.city" v-model:dist="form.dist"
                                        placeholder="请选择省/市/区" />
                                </a-form-item></a-col>
                <a-col :span="12">
                    <a-form-item label="详细地址" prop="locationAddress">
                                    <a-input v-model:value="form.locationAddress" placeholder="请输入详细地址" />
                                </a-form-item></a-col>
                <a-col :span="12">
                    <a-form-item label="统一社会信用代码" prop="unifiedSocialCreditCode">
                                    <a-input v-model:value="form.unifiedSocialCreditCode" placeholder="请输入统一社会信用代码" />
                                </a-form-item></a-col>
                <a-col :span="12"><a-form-item label="注册时间" prop="registrationTime">
                                    <date-picker v-model:value="form.registrationTime" placeholder="请输入注册时间"/>
                                </a-form-item>
                            </a-col>
                <a-col :span="12" ><a-form-item label="法人代表" prop="legalPerson">
                                    <a-input v-model:value="form.legalPerson" placeholder="请输入法人代表" />
                                </a-form-item></a-col>
                <a-col :span="12" ><a-form-item label="联系人" prop="contactName">
                                    <a-input v-model:value="form.contactName" placeholder="请输入联系人" />
                                </a-form-item></a-col>
                <a-col :span="12" > <a-form-item label="联系电话" prop="telephone">
                                    <a-input v-model:value="form.telephone" placeholder="请输入联系电话" />
                                </a-form-item></a-col>
                <a-col :span="24" >
                    <a-form-item label="机构简介" prop="briefIntroduction">
                                    <a-textarea v-model:value="form.briefIntroduction" placeholder="请输入机构简介"
                                        :auto-size="{ minRows: 5, maxRows: 6 }" />
                                </a-form-item></a-col>

                <!-- 可编辑区域 end
                <div class='text-center mt-20'>
                    <a-button type="primary" @click="onSubmit">保存</a-button>
                </div> -->

      </a-row>
      <!--可编辑区域 end-->
    </a-form>
  </a-modal>
</template>
<script>
import { formMixin } from "@/mixins";
import { financeInstitution } from "@/api/finance";
  import DictSelect from "@/components/other/DictSelect";
import { financeDict } from "@/config/variableConfig";
import dataCheck from "@/utils/dataCheck";


export default {
  name: "InstitutionModal",
  components: { DictSelect, },
  mixins: [formMixin],
  data() {
        return {
            financeDict,
            form: {
                id: null,
                name: null,
                type: null,
                postcard: null,
                webSite: null,
                email: null,
                locationAddress: null,
                prov: null,
                city: null,
                dist: null,
                logo: null,
                unifiedSocialCreditCode: null,
                registrationTime: null,
                legalPerson: null,
                contactName: null,
                telephone: null,
                auditStatus: null,
                feedback: null,
                enabled: null,
                experience: null,
                successCases: null,
                views: null,
                keyWord: null,
                briefIntroduction: null,
            },
            rules: {
                id: [],
                name: [dataCheck.required({})],
                // type: [dataCheck.required({type:'number'}),dataCheck.number],
                // postcard: [dataCheck.required({})],
                // webSite: [dataCheck.required({})],
                type: [],
                postcard: [],
                webSite: [],
                email: [dataCheck.required({})],
                locationAddress: [dataCheck.required({})],
                prov: [dataCheck.required({})],
                city: [dataCheck.required({})],
                dist: [dataCheck.required({})],
                logo: [],
                unifiedSocialCreditCode: [dataCheck.required({})],
                // registrationTime: [dataCheck.required({})],
                registrationTime: [],
                legalPerson: [dataCheck.required({})],
                contactName: [dataCheck.required({})],
                telephone: [dataCheck.required({})],
                auditStatus: [dataCheck.required({})],
                feedback: [dataCheck.required({})],
                enabled: [dataCheck.required({})],
                experience: [dataCheck.required({})],
                successCases: [dataCheck.required({})],
                views: [dataCheck.required({})],
                keyWord: [dataCheck.required({})],
                briefIntroduction: [dataCheck.required({})],
            },
            submitUrl: financeInstitution.edit
        }
    },
    // computed: {
    //         submitUrl() {
    //             console.log(this.form,"0000000000000000000000");
    //             if (this.form.id) {
    //                 // console.log(this.form,"0000000000000000000000");
    //                 // this.onShowModal('financeInstitution', this.form);
    //                 return financeInstitution.edit
    //             } else {
    //                 return financeInstitution.add
    //             }
    //         }
    //     },
}
</script>
<style scoped lang="less"></style>
